import React from "react";
import TestApp from "./Tests";
import { Box, Typography } from "@mui/material";
import AnyTestComponent from "./AnyTestComponent";


const MathComponent = () => {
  return (
    <AnyTestComponent 
    questionCount={40} 
    title={'Math Component'} 
    componentType={'math'}
    >
    </AnyTestComponent>
  );
}

export default MathComponent;
